import * as React from 'react';
import { initializeIcons } from '@fluentui/react/lib/Icons';
import Constants from '../libraries/Constants';
import _ from 'lodash';
import RbTabNavigation, { INavItem } from '../../bosch-react/components/tab-navigation/RbTabNavigation';
import { IUserPermissions } from '../../features/Auth/types';
import { RootState } from '../../store/store';
import { connect } from 'react-redux';

class TopNavigation extends React.Component<any, any> {

    wrapperRef: React.RefObject<HTMLDivElement> = React.createRef();

    constructor(props: any) {
        super(props);
        initializeIcons();
        this.state = {
            MenuItems: [],
            // Mobile-only: whether the hamburger drawer is expanded
            isMobileMenuOpen: false,
        }
        this.handleClick = this.handleClick.bind(this);
        this.toggleMobileMenu = this.toggleMobileMenu.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleOnClickExternalLink(externalURL: string | undefined): void {
        window.open(externalURL);
    }

    // Closes the mobile drawer when tapping/clicking anywhere outside of it
    handleClickOutside(event: MouseEvent) {
        if (this.state.isMobileMenuOpen && this.wrapperRef.current && !this.wrapperRef.current.contains(event.target as Node)) {
            this.setState({ isMobileMenuOpen: false });
        }
    }

    toggleMobileMenu() {
        this.setState((prevState: any) => ({ isMobileMenuOpen: !prevState.isMobileMenuOpen }));
    }

    render() {
        const menuItems = !!this.props.userProfile&&this.props.userProfile.menuItems
        return (
            <div
                className={"Nav" + (this.state.isMobileMenuOpen ? " mobile-open" : "")}
                ref={this.wrapperRef}
            >
                {/* Mobile-only hamburger toggle — hidden on desktop via CSS */}
                <button
                    type="button"
                    className="nav-mobile-toggle"
                    aria-label={this.state.isMobileMenuOpen ? "Close navigation menu" : "Open navigation menu"}
                    aria-expanded={this.state.isMobileMenuOpen}
                    onClick={this.toggleMobileMenu}
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
                {!!menuItems&&<RbTabNavigation items={menuItems}/>}
            </div>
        );
    }

    handleClick(url: string) {
        console.log(url);
    }

}
const mapStateToProps = (state: RootState) => ({
    userProfile: state.auth.userProfile,
  });
export default connect(mapStateToProps)(TopNavigation);